import PageHeader from "@/components/PageHeader";
import { memo } from "react";
import UserCreatorForm from "./UserCreatorForm";
import { useUserBreadcrumbs } from "../hooks";
import { UsersProvider } from "../context";

const UserCreator = memo(() => {
  const { breadcrumbItems } = useUserBreadcrumbs();

  return (
    <UsersProvider>
      <PageHeader breadcrumbItems={breadcrumbItems} />
      <UserCreatorForm />
    </UsersProvider>
  );
});

export default UserCreator;
